import { render, staticRenderFns } from "./AccountDeletionModal.vue?vue&type=template&id=94be95a0&scoped=true"
import script from "./AccountDeletionModal.vue?vue&type=script&lang=ts"
export * from "./AccountDeletionModal.vue?vue&type=script&lang=ts"
import style0 from "./AccountDeletionModal.vue?vue&type=style&index=0&id=94be95a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94be95a0",
  null
  
)

export default component.exports